import { useRef, useEffect } from 'react';
import Loading from '@ebsco-ui/loading';
import Button from '@ebsco-ui/button';
import { createBemBlockBuilder } from '@ebsco-ui/utils';
import { faFileAlt } from '@fortawesome/pro-regular-svg-icons/faFileAlt';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

var ShowMorePagination = function ShowMorePagination(_ref) {
  var renderPage = _ref.children,
      _ref$pagesContainerTa = _ref.pagesContainerTag,
      PagesContainerTag = _ref$pagesContainerTa === void 0 ? "section" : _ref$pagesContainerTa,
      className = _ref.className,
      LoadingIndicator = _ref.loadingIndicator,
      messages = _ref.messages,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? false : _ref$error,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      onLoadPage = _ref.onLoadPage,
      pages = _ref.pages,
      _ref$recordsPerPage = _ref.recordsPerPage,
      recordsPerPage = _ref$recordsPerPage === void 0 ? 10 : _ref$recordsPerPage,
      totalRecords = _ref.totalRecords,
      uniqueName = _ref.uniqueName;
  var pagesAvailable = Math.ceil(totalRecords / recordsPerPage);
  var hasPagesToLoad = pagesAvailable > pages.length;
  var getBlocksWith = createBemBlockBuilder(["eb-pagination", className]);
  var loadingSpinnerRef = useRef(null);
  useEffect(function () {
    if (isLoading && loadingSpinnerRef.current) {
      loadingSpinnerRef.current.focus();
    }
  }, [isLoading]);

  var getFooterContent = function getFooterContent() {
    if (hasPagesToLoad) {
      if (isLoading) {
        return /*#__PURE__*/jsx("div", {
          className: getBlocksWith("__loading-indicator"),
          tabIndex: -1,
          ref: loadingSpinnerRef,
          children: LoadingIndicator ? /*#__PURE__*/jsx(LoadingIndicator, {}) : /*#__PURE__*/jsx(Loading, {
            direction: "horizontal",
            size: "small",
            loadingMessage: messages.loading
          })
        });
      } else {
        return /*#__PURE__*/jsxs(Button, {
          "aria-controls": uniqueName,
          className: getBlocksWith("__button"),
          onClick: onLoadPage,
          type: "button",
          styleType: "default",
          "data-auto": "show-more-button",
          children: [/*#__PURE__*/jsx(FontAwesomeIcon, {
            className: getBlocksWith("__button-icon"),
            icon: faFileAlt
          }), messages.showMoreButtonTitle]
        });
      }
    } else {
      return /*#__PURE__*/jsx("div", {
        className: "screen-reader-text",
        children: messages.endOfList
      });
    }
  };

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(PagesContainerTag, {
      id: uniqueName,
      className: getBlocksWith(),
      children: pages.map(renderPage)
    }), getFooterContent(), error && !isLoading && /*#__PURE__*/jsx("div", {
      className: getBlocksWith("__error-message"),
      role: "alert",
      children: messages.error
    })]
  });
};

export { ShowMorePagination as default };
//# sourceMappingURL=show-more-pagination-esm.js.map
